// import React, { useEffect, useState } from 'react';
// import { createClient } from '@supabase/supabase-js';

// // Initialize Supabase client
// const supabase = createClient(process.env.REACT_APP_SUPABASE_URL,process.env.REACT_APP_ANON_KEY);

// const RoleTable = () => {
//   const [users, setUsers] = useState([]);
//   const [editingUserId, setEditingUserId] = useState(null);
//   const [editingRole, setEditingRole] = useState('');
//   const [loading, setLoading] = useState(false);

//   // Fetch data from Supabase
//   const fetchUsers = async () => {
//     setLoading(true);
//     const { data, error } = await supabase.from('user').select('*');
//     if (error) {
//       console.error('Error fetching users:', error);
//     } else {
//       setUsers(data);
//     }
//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const startEditing = (userId, currentRole) => {
//     setEditingUserId(userId);
//     setEditingRole(currentRole);
//   };

//   const cancelEditing = () => {
//     setEditingUserId(null);
//     setEditingRole('');
//   };

//   const saveRole = async (userId) => {
//     const { error } = await supabase
//       .from('users')
//       .update({ role: editingRole })
//       .eq('id', userId);

//     if (error) {
//       console.error('Error updating role:', error);
//     } else {
//       setUsers((prevUsers) =>
//         prevUsers.map((user) =>
//           user.id === userId ? { ...user, role: editingRole } : user
//         )
//       );
//       cancelEditing();
//     }
//   };

//   return (
//     <div>
//       <h2>User Roles</h2>
//       {loading ? (
//         <p>Loading...</p>
//       ) : (
//         <table border="1">
//           <thead>
//             <tr>
//               <th>ID</th>
//               <th>Name</th>
//               <th>Email</th>
//               <th>Role</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {users.map((user) => (
//               <tr key={user.id}>
//                 <td>{user.id}</td>
//                 <td>{user.name}</td>
//                 <td>{user.email}</td>
//                 <td>
//                   {editingUserId === user.id ? (
//                     <select
//                       value={editingRole}
//                       onChange={(e) => setEditingRole(e.target.value)}
//                     >
//                       <option value="user">User</option>
//                       <option value="admin">Admin</option>
//                     </select>
//                   ) : (
//                     user.role
//                   )}
//                 </td>
//                 <td>
//                   {editingUserId === user.id ? (
//                     <>
//                       <button onClick={() => saveRole(user.id)}>Save</button>
//                       <button onClick={cancelEditing}>Cancel</button>
//                     </>
//                   ) : (
//                     <button onClick={() => startEditing(user.id, user.role)}>
//                       Edit
//                     </button>
//                   )}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       )}
//     </div>
//   );
// };

// export default RoleTable;

import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../api/productapi";
import Loader from "./Loader";
// import useAuth from "../../Hooks/Auth";
// import { supabase } from '../../utils/SupabaseClient';// Ensure correct import path for SupabaseClient

function DisplayTable() {
  const [data, setData] = useState([]); // State to hold table data
  const [loading, setLoading] = useState(false); // State for loading indicator
  const [error, setError] = useState(null); // State for error handling
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);

  const [newUserToggle, setNewUserToggle] = useState(false);

  const [rowId, setRowId] = useState(null);


  const [updateUser, setUpdateUser] = useState({});
  // const {role} = useAuth();

  const [newUser, setNewUser] = useState({
    email: "",
    name: "",
    is_active: Boolean,
    role: "",
    password: "",
  });

  const [errors, setErrors] = useState({});   //Validate input

  useEffect(() => {
    const fetchData = async () => {
      //   try {
      //     const { data: tableData, error } = await supabase
      //       .from('user') // Replace 'user' with your actual table name
      //       .select('*'); // Fetch all columns

      //     if (error) throw error; // Handle error

      //     setData(tableData || []); // Update data state
      //   } catch (err) {
      //     setError(err.message); // Set error message
      //   } finally {
      //     setLoading(false); // Hide loading spinner
      //   }
      setLoading(true); // ✅ Show loading state

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URI}/auth/dashboard`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

    

        // ✅ Ensure the request was successful
        if (response.status !== 200) {
          throw new Error("Failed to fetch data. Please try again.");
        }

        const data = response.data?.Users;

        if (!data || !Array.isArray(data)) {
          throw new Error("Invalid data received from the server.");
        }


        setData(data);
        setFilteredSuggestions(data);
      } catch (error) {
        console.error("Fetch Data Error:", error);

        if (error.response) {
          // ✅ Handle API errors
          setError(error.response.data?.message || "Unable to fetch data. Please try again.");
        } else if (error.request) {
          // ✅ Handle network issues
          setError("Network error. Please check your connection.");
        } else {
          // ✅ Handle unexpected errors
          setError("An unexpected error occurred. Please try again.");
        }
      } finally {
        setLoading(false); // ✅ Hide loading state
      }
    };

    fetchData();
  }, []);

  const handleSearch = (e) => {
    const { value } = e.target;

    setSearchTerm(value);


    const filteredUsers = data.filter((current) => {
      return (
        current.email.toLowerCase().includes(value.toLowerCase()) ||
        current.name.toLowerCase().includes(value.toLowerCase()) ||
        String(current.is_active).toLowerCase().includes(value.toLowerCase()) ||
        current.role.toLowerCase().includes(value.toLowerCase())
      );
    });

    setFilteredSuggestions(value ? filteredUsers : data);
  };

  const toggleUser = (e) => {
    setNewUserToggle((prev) => !prev);

  };

  const toggleEditMode = (index) => {
    setRowId(index);
    setUpdateUser({
      email: filteredSuggestions[index].email || "",
      name: filteredSuggestions[index].name || "",
      is_active: filteredSuggestions[index].is_active.toString() || "",
      role: filteredSuggestions[index].role || "",
      password: filteredSuggestions[index].password || "",
    });
    // setEditMode((prev) => !prev);
  };



  const toggleCancel = () => {
    setNewUser({
      email: "",
      name: "",
      is_active: false,
      role: "",
      password: "",
    })
    setErrors({});
    setRowId(null);

  }

  const handleSave = async (index) => {

 

    if (
      updateUser.email === undefined || updateUser.email === "null" || updateUser.email === '' ||
      updateUser.password === undefined || updateUser.password === 'null' || updateUser.password === '' ||
      updateUser.name === undefined || updateUser.name === 'null' || updateUser.name === '' ||
      updateUser.is_active === undefined || updateUser.is_active === 'null' || updateUser.is_active === '' ||
      updateUser.role === undefined || updateUser.role === 'null' || updateUser.role === ''
    ) {
      toast.error("Please fill all details");
      return;
    }

    //update user details
    try {

      if(validateUpdateInputs()){
   
      const payload = {
        email: updateUser.email.trim(),
        password: updateUser.password.trim(),
        name: updateUser.name.trim(),
        is_active: updateUser.is_active,
        role: updateUser.role
      }

 
      const res = await api.patch(`/auth/${filteredSuggestions[index].email}`, payload)

      if (res.status !== 200) {
        throw new Error(res.data);
      } else {
        toast.success("Data Updated Successfully!!");
        alert("Data Updated Successfully!!");
      }

      //Update details in UI when data sent successfully
      setFilteredSuggestions((prev) =>
        prev.map((user, idx) =>
          idx === index ? { ...user, ...updateUser } : user
        )
      );

      setData((prev) =>
        prev.map((user, idx) =>
          idx === index ? { ...user, ...updateUser } : user
        )
      );

      // toast.success("Data Updated Successfully!!");
      setRowId(null);
    }else {
      toast.error("Error sending data");
      console.error("Error sending data");
    }
    } catch (error) {

      console.error("Error updating user:", error);

      // Display a user-friendly error message
      if (error.response) {
        // Server responded with an error status

        // duplicate entry update
        if(error.status === 500){
          if(error.response.data.detail.includes("Duplicate entry")){
            toast.error("Duplicate entry, Please check whether email is not duplicate!");
          }
        }
        // toast.error(error.response.data?.detail || "An error occurred while updating.");
      } else if (error.request) {
        // Request was made but no response received
        toast.error("Server did not respond. Please try again later.");
      } else {
        // Some other error occurred
        toast.error("Something went wrong. Please try again.");
      }
    }
  }

  //Track input change of new users
  const handleNewUser = (e) => {
    const { name, value } = e.target;

    setNewUser((prev) => ({
      ...prev,
      [name]: name === 'is_active'
        ? value === "" ? "" : value.toLowerCase() === "true"
        : value,
    }));
  };

  // Track input change of specific user
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    setUpdateUser((prev) => (
      {
        ...prev,
        [name]: name === "is_active" ? (value === "" ? "" : value.toLowerCase() === "true") : value,
      }
    ))
  };
  // const isFormComplete = Object.values(newUser).every((value) => value.trim() !== "");

  const validateInputs = () => {
    let validationErrors = {};

    if (!newUser.email || !/^\S+@\S+\.\S+$/.test(newUser.email)) {
      validationErrors.email = "Enter a valid email";
    }

    if (!newUser.password || newUser.password.length < 6) {
      validationErrors.password = "Password must be at least 6 characters";
    }

    if (!newUser.name.trim()) {
      validationErrors.name = "Name is required";
    }

    if (newUser.is_active === undefined || newUser.is_active === null | newUser.is_active === "") {
      validationErrors.is_active = "Select status";
    }

    if (!newUser.role) {
      validationErrors.role = "Select a role";
    }

    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0; // Return true if no errors
  };

  const validateUpdateInputs = () => {
    let validationErrors = {};

    if (!updateUser.email || !/^\S+@\S+\.\S+$/.test(updateUser.email)) {
      validationErrors.email = "Enter a valid email";
    }

    if (!updateUser.password || updateUser.password.length < 6) {
      validationErrors.password = "Password must be at least 6 characters";
    }

    if (!updateUser.name.trim()) {
      validationErrors.name = "Name is required";
    }

    if (updateUser.is_active === undefined || updateUser.is_active === null | updateUser.is_active === "") {
      validationErrors.is_active = "Select status";
    }

    if (!updateUser.role) {
      validationErrors.role = "Select a role";
    }

    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0; // Return true if no errors
  };



  const handleSubmit = async () => {

    if (
      newUser.email === undefined || newUser.email === "null" || newUser.email === '' ||
      newUser.password === undefined || newUser.password === 'null' || newUser.password === '' ||
      newUser.name === undefined || newUser.name === 'null' || newUser.name === '' ||
      newUser.is_active === undefined || newUser.is_active === 'null' || newUser.is_active === '' ||
      newUser.role === undefined || newUser.role === 'null' || newUser.role === ''
    ) {
      toast.error("Please fill all details");
      return;
    }

    try {

      if (validateInputs()) {
        const data = {
          email: newUser.email.trim(),
          name: newUser.name.trim(),
          is_active: newUser.is_active,
          role: newUser.role,
          password: newUser.password.trim(),
        };

        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URI}/auth/create`,
          data,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          toast.success("User Added Successfully");
          alert('User Added Successfully')

          setNewUser({
            email: "",
            name: "",
            is_active: false,
            role: "",
            password: "",
          });

          setFilteredSuggestions((prev) => [...prev, newUser]);
          setErrors({});
          setNewUserToggle(false);

        } else {
          toast.error("Error sending data");
          console.error("Error sending data");
        }
      } else {
        throw new Error("validation error", errors);
      }
    } catch (error) {
      if (error.response) {
        
        console.error("Error Response Data:", error.response.data);
        toast.error(error.response.data.detail)
        console.error("Error Status:", error.response.status);
      } else {
        console.error("Network Error:", error.message);
      }
    }
  };

  const handleKeyPress = async (event) => {
    if (event.key === "Enter") {
      await handleSubmit();
    }
  };

  const navigate = useNavigate();

  if (loading) return <Loader />; // Show loading message while fetching data
  if (error) return <p>Error: {error}</p>; // Show error if fetch fails

  return (
    <div className="bg-slate-700 h-screen ">
      <div className="flex flex-col bg-slate-700 justify-center items-center overflow-auto">
        <div className="w-full p-4">
          <div className="relative w-full">
            <button
              className="px-6 py-2 bg-slate-800 rounded-2xl mt-2 hover:bg-slate-950 absolute left-0"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
          </div>
          <h1 className="text-2xl font-semibold tracking-wide text-center my-16 sm:my-8 md:my-12 lg:my-12">
            User Information
          </h1>

          <div className="flex flex-col sm:flex-row justify-between w-full my-6 gap-4 sm:gap-0">
            <div className="relative w-full sm:w-2/3 lg:w-1/2 mx-auto sm:mx-4">
              <FaSearch className="absolute left-3 top-3 text-white" />
              <input
                type="text"
                placeholder="Search Users.."
                value={searchTerm}
                onChange={handleSearch}
                className="pl-10 bg-gray-900 text-white rounded px-4 py-2 w-full"
              />
            </div>
            <div className="flex justify-center sm:justify-end w-full sm:w-1/3 lg:w-1/4">
              <button
                className={`w-full sm:w-48 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mx-4 ${newUserToggle ? 'hidden' : 'inline'}`}
                onClick={toggleUser}
              >
                {newUserToggle ? 'Cancel' : '+ Add User'}
              </button>
            </div>
          </div>
        </div>


        <div className="overflow-x-auto w-full p-4 shadow-md sm:rounded-lg relative ">
          <table className="bg-gray-800 w-full border border-gray-500 text-white text-sm md:text-base table-auto ">
            <thead>
              <tr className="bg-gray-900 text-center font-bold text-xs md:text-sm lg:text-base">
                <td className="p-2 md:p-4">EMAIL</td>
                <td className="p-2 md:p-4">PASSWORD</td>
                <td className="p-2 md:p-4">NAME</td>
                <td className="p-2 md:p-4">ACTIVE</td>
                <td className="p-2 md:p-4">ROLE</td>
                <td className="p-2 md:p-4">EDIT</td>
              </tr>
            </thead>
            <tbody>
              {filteredSuggestions.map((user, index) => (
                <>
                <tr key={index} className="text-center text-xs md:text-sm lg:text-base">
                  <td className="p-2 ">
                    {rowId === index ? (
                      <>
                      <input
                        type="email"
                        name="email"
                        value={updateUser.email}
                        onChange={(e) => handleInputChange(e, index)}
                        className="border p-1 md:p-2 rounded bg-gray-700 w-full"
                        required
                      />
                      {errors?.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
                      </>
                    ) : (
                      <span className="whitespace-nowrap">{user.email}</span>
                    )}
                  </td>
                  <td className="p-2">
                    {rowId === index ? (
                      <>
                      <input
                        type="text"
                        name="password"
                        value={updateUser.password}
                        onChange={(e) => handleInputChange(e, index)}
                        className="border p-1 md:p-2 rounded bg-gray-700 w-full"
                        required
                      />
                      {errors?.password && <p className="text-red-500 text-xs mt-1">{errors.password}</p>}
                      </>
                    ) : (
                      <span className="whitespace-nowrap">{user.password}</span>
                    )}
                  </td>
                  <td className="p-2">
                    {rowId === index ? (
                       <>
                       <input
                         type="text"
                         name="name"
                         value={updateUser.name}
                         onChange={(e) => handleInputChange(e, index)}
                         className="border p-1 md:p-2 rounded bg-gray-700 w-full"
                         required
                       />
                       {errors?.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
                     </>
                    ) : (
                      <span className="whitespace-nowrap">{user.name}</span>
                    )}
                  </td>
                  <td className="p-2">
                    {rowId === index ? (
                       <>
                       <select
                         name="is_active"
                         value={updateUser.is_active.toString()}
                         onChange={(e) => handleInputChange(e, index)}
                         className="border rounded px-2 md:px-3 py-1 bg-gray-700 w-full"
                         required
                       >
                         <option value="">Select Status</option>
                         <option value="true">True</option>
                         <option value="false">False</option>
                       </select>
                       {errors?.is_active && <p className="text-red-500 text-xs mt-1">{errors.is_active}</p>}
                     </>
                    ) : (
                      user.is_active.toString()
                    )}
                  </td>
                  <td className="p-2">
                    {rowId === index ? (
                      <>
                      <select
                        name="role"
                        value={updateUser.role}
                        onChange={(e) => handleInputChange(e, index)}
                        className="border rounded px-2 md:px-3 py-1 bg-gray-700 w-full"
                        required
                      >
                        <option value="">Select Role</option>
                        <option value="admin">Admin</option>
                        <option value="user">User</option>
                      </select>
                      {errors?.role && <p className="text-red-500 text-xs mt-1">{errors.role}</p>}
                    </>
                    ) : (
                      user.role
                    )}
                  </td>
                  <td className="p-2">
                    {rowId === index ? (
                      <div className="flex justify-center gap-2">
                        <button className="px-2 bg-red-600 rounded hover:bg-red-700" onClick={toggleCancel}>
                          Cancel
                        </button>
                        <button className="px-2 bg-green-600 rounded hover:bg-green-700" onClick={() => handleSave(index)}>
                          Save
                        </button>
                      </div>
                    ) : (
                      <button className="px-2 bg-green-600 rounded" onClick={() => toggleEditMode(index)}>
                        Edit
                      </button>
                    )}
                  </td>
                </tr>
                {/* {
                 (rowId === index) && errors  && (
                    <tr className="text-center text-xs md:text-sm lg:text-base">
                      {
                        Object.entries(errors).map(([key, value]) => (
                          <td className="text-center mt-1">
                            <p className="text-red-500">{value}</p>
                          </td>
                        ))
                      }
                    </tr>
                  )
                } */}
                </>
              ))}
              {newUserToggle && (
                <>
                  <tr className="text-center text-xs md:text-sm lg:text-base">
                    <td className="p-2">
                      <input
                        type="email"
                        name="email"
                        placeholder="Enter email.."
                        value={newUser.email}
                        onChange={handleNewUser}
                        className="border p-1 md:p-2 rounded bg-gray-700 w-full"
                        required
                      />

                    </td>
                    <td className="p-2">
                      <input
                        type="text"
                        name="password"
                        placeholder="Enter password.."
                        value={newUser.password}
                        onChange={handleNewUser}
                        className="border p-1 md:p-2 rounded bg-gray-700 w-full"
                        required
                      />

                    </td>
                    <td className="p-2">
                      <input
                        type="text"
                        name="name"
                        placeholder="Enter name.."
                        value={newUser.name}
                        onChange={handleNewUser}
                        className="border p-1 md:p-2 rounded bg-gray-700 w-full"
                        required
                      />
                    </td>

                    <td className="p-2">
                      <select
                        name="is_active"
                        value={newUser.is_active}
                        onChange={handleNewUser}
                        className="border rounded px-2 md:px-3 py-1 bg-gray-700 w-full"
                        required
                      >
                        <option value="">Select Status</option>
                        <option value="true">True</option>
                        <option value="false">False</option>
                      </select>

                    </td>
                    <td className="p-2">
                      <select
                        name="role"
                        value={newUser.role}
                        onChange={handleNewUser}
                        className="border rounded px-2 md:px-3 py-1 bg-gray-700 w-full"
                        required
                      >
                        <option value="">Select Role</option>
                        <option value="admin">Admin</option>
                        <option value="user">User</option>
                      </select>

                    </td>
                    <td className="p-2">
                      <div className="flex justify-center gap-2">
                        <button className="px-2 bg-red-600 rounded hover:bg-red-700" onClick={() => setNewUserToggle(false)}>
                          Cancel
                        </button>
                        <button className="px-2 bg-green-600 rounded hover:bg-green-700" onClick={handleSubmit}>
                          Save
                        </button>
                      </div>
                    </td>
                  </tr>
                  {
                    errors && (
                      <tr className="text-center text-xs md:text-sm lg:text-base">
                        {
                          Object.entries(errors).map(([key, value]) => (
                            <td className="text-center mt-1">
                              <p className="text-red-500">{value}</p>
                            </td>
                          ))
                        }
                      </tr>
                    )
                  }
                </>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default DisplayTable;

// {data.length > 0 ? (
//   <table border="1">
//     <thead>
//       <tr>
//         {/* Adjust columns to match your table structure */}
//         <th>ID</th>
//         <th>Role</th>
//         <th>Email</th>
//       </tr>
//     </thead>
//     <tbody>
//       {data.map((row) => (
//         <tr key={row.id}>
//           <td>{row.id}</td>
//           <td>{row.role}</td>
//           <td>{row.email}</td>
//         </tr>
//       ))}
//     </tbody>
//   </table>
// ) : (
//   <p>No data available</p> // Show this if table is empty
// )
